// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption2":"_3FCgXshmQfWC83mTTDn6Lf","caption":"_1dJD2pSCq2-UhXWE_3mRfd","borderGrey":"#d5dfdf","smallMaxWidth":"991px","body":"_2lYHSCAcM6vA2s-47YYZeS","label":"_3q_iNcE7XyM4xYaMQFGlWj _3FCgXshmQfWC83mTTDn6Lf","text":"_1RqyQnGjZzd8APKs6fwVBR _1dJD2pSCq2-UhXWE_3mRfd","select":"GBxSBdm9tWoVeEExdksVT","selectPhone":"_2djFX9xqfonP_YTT6IMX95 _2lYHSCAcM6vA2s-47YYZeS","input":"_1JcBKlvlMGPCTO5CLUJqAH","button":"uOHrrrHrdBaXn5KncZi7-"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/shipping-options/phone-selection/PhoneSelection.css
// module id = 722
// module chunks = 0